import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { authServices } from '../authServices'
import {
  VerifyCodeDTO,
  CheckRecoveryCodeSentToEmailPayload,
} from '../authTypes'

import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useCheckRecoveryCodeSentToEmail = (
  options?: IOptionsUseMutation<VerifyCodeDTO>,
) => {
  const { t } = useTranslation()

  return useMutation<
    VerifyCodeDTO,
    ErrorDetail,
    CheckRecoveryCodeSentToEmailPayload
  >({
    mutationFn: authServices.checkRecoveryCodeSentToEmail,
    onSuccess: (data) => {
      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (code === ApiErrorCode.VERIFICATION_CODE_INVALID) {
        errorMessage = t('api:validationErrors.invalidCode')
      }

      if (code === ApiErrorCode.VERIFICATION_CODE_EXPIRED) {
        errorMessage = t('api:validationErrors.codeExpired')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage, code })
      }
    },
  })
}
